var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"s-button",class:_vm.classes,on:{"click":_vm.handleClick}},[(_vm.icon)?_c('s-icon',{staticClass:"s-button__icon",attrs:{"icon":_vm.icon}}):_vm._e(),_c('span',{staticClass:"s-button__inner"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }